import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useTheme } from "@/themes/themes";

const WORDMARK_URL = "/havn-logo-white.png";

export default function IntroPage() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  // Auto-advance to tutorial after animation
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/tutorial', { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="havn-container" style={{
      backgroundImage: `radial-gradient(ellipse at center, transparent 0%, transparent 40%, rgba(0,0,0,0.12) 100%), url(${theme.backgroundImage || '/assets/Smooth_blue_gradient_backdrop.png'})`,
      backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
      backgroundColor: theme.background,
    }} data-testid="intro-page">
      {/* No bg-gradient div needed - container has gradient */}
      
      <main className="flex flex-col items-center justify-center flex-1 z-10 gap-8">
        {/* Hero Orb - perfect circle, transparent bg, NO framing */}
        <motion.div
          className="relative"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ 
            duration: 0.8, 
            ease: [0.34, 1.56, 0.64, 1] // Spring-like
          }}
        >
          {/* Glow - themed, viewport-based sizing */}
          <motion.div
            className="hero-orb-glow-themed glow-state-safe"
            initial={{ opacity: 0 }}
            animate={{ 
              opacity: [0.3, 0.5, 0.3],
              scale: [1, 1.1, 1]
            }}
            transition={{ 
              delay: 0.3,
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          
          {/* Orb - themed, breathing animation starts immediately */}
          <motion.img
            src={theme.orbImage || '/assets/orb_havn_v4.png'}
            alt="HAVN"
            className="hero-orb hero-orb-themed orb-state-safe"
            animate={{ 
              scale: [1, 1.03, 1]
            }}
            transition={{ 
              delay: 0.5,
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            data-testid="intro-orb"
          />
        </motion.div>

        {/* Wordmark - appears AFTER orb, viewport-scaled */}
        <motion.img
          src="/havn-logo-white.png"
          alt="HAVN"
          style={{ height: '28px', width: 'auto', objectFit: 'contain' }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            delay: 1.0,
            duration: 0.8,
            ease: "easeOut"
          }}
          data-testid="intro-wordmark"
        />
      </main>
    </div>
  );
}
